import { useMemo } from 'react'
import { useQueryParams } from 'src/hooks/useQueryParams'
import { FilterPeriod } from 'src/constants/filterPeriods/enums/filterPeriod.enum'
import { GlobalQueryParams } from 'src/interfaces/globalQueryParams.interface'
import { ContentAnalysisV2Scope } from 'src/services/contentAnalysisApi/interfaces/contentAnalysisV2.interface'
import { getDateRangeByQueryParams } from 'src/utils/getDateRangeByQueryParams'

export type ContentAnalysisV2Range = Pick<
  ContentAnalysisV2Scope,
  'from' | 'period' | 'to'
>

// The top-bar range for the `/content-analysis/v2/*` reads. On Lifetime only
// `period=lifetime` is sent: the top bar still writes the analysis's active
// range into ?from/?to for its own label, but any bound makes sm.back drop
// undated posts and comments, which Lifetime must include. It also tells the
// backend there is no previous period, so every delta comes back null.
export const useContentAnalysisV2Range = (): ContentAnalysisV2Range => {
  const { queryParams } = useQueryParams<GlobalQueryParams>()
  const isLifetime = queryParams.period === FilterPeriod.LIFETIME
  const dates = getDateRangeByQueryParams(queryParams)
  const from = dates?.start
  const to = dates?.end

  return useMemo(
    () =>
      isLifetime
        ? { from: undefined, period: 'lifetime' as const, to: undefined }
        : { from, period: undefined, to },
    [from, isLifetime, to]
  )
}
